import React from 'react';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { DepotSummary, UserAccessProfile } from '../../../models/userManagement';

interface MyAccessTabProps {
  profile: UserAccessProfile;
}

const MyAccessTab: React.FC<MyAccessTabProps> = ({ profile }) => {
  const depots = profile.assignedDepots || [];

  return (
    <Stack spacing={3}>
      <Card variant="outlined">
        <CardContent>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
            <Avatar sx={{ width: 64, height: 64 }} src={profile.avatarUrl}>
              {profile.name?.[0] || profile.email[0]}
            </Avatar>
            <Box>
              <Typography variant="h6">{profile.name || profile.email}</Typography>
              <Typography variant="body2" color="text.secondary">
                {profile.email}
              </Typography>
              <Stack direction="row" spacing={1} mt={1} flexWrap="wrap">
                {profile.roles.map((role) => (
                  <Chip key={role} label={role.replace('_', ' ')} size="small" color="primary" variant="outlined" />
                ))}
              </Stack>
            </Box>
          </Stack>
        </CardContent>
      </Card>

      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle1" gutterBottom>
            Tenant & Access
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" color="text.secondary">
                Tenant
              </Typography>
              <Typography variant="body1">{profile.tenantName || profile.tenantId || 'Multiple / Global'}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" color="text.secondary">
                Assigned Depots
              </Typography>
              <Typography variant="body1">{depots.length}</Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle1" gutterBottom>
            Depot Access
          </Typography>
          {depots.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No depots assigned yet.
            </Typography>
          ) : (
            <List disablePadding>
              {depots.map((depot: DepotSummary) => (
                <React.Fragment key={depot.depotId}>
                  <ListItem disableGutters>
                    <ListItemText
                      primary={depot.name}
                      secondary={`${depot.depotId} • ${depot.tenantId} • ${depot.modelType}`}
                    />
                  </ListItem>
                  <Divider component="li" />
                </React.Fragment>
              ))}
            </List>
          )}
        </CardContent>
      </Card>
    </Stack>
  );
};

export default MyAccessTab;
